
export const setOrg = ({ commit }, payload) => {
    commit("setOrg", payload);
    commit("setImageOrg", null);
};
export const setLastUpdatedDataOrg = ({ commit }, payload) => {
    commit("setLastUpdatedDataOrg", payload)
};
export const setImageOrg = ({ commit }, payload) => {
    commit("setImageOrg", payload);
};

export const setSolicitation = ({ commit }, payload) => {
    commit("setSolicitation", payload);
};


